var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContabilidad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-contabilidad"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contabilidad",
    clipPath: "url(#clip-contabilidad)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2106",
    "data-name": "Grupo 2106",
    transform: "translate(-11.821 -3.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_811",
    "data-name": "Trazado 811",
    d: "M86.174,25.466C86.174,16.934,70.012,10,50.087,10S14,16.934,14,25.466m72.174,0V46.087c0,5.258-6.109,9.9-15.466,12.682a73.094,73.094,0,0,1-20.621,2.784,73.094,73.094,0,0,1-20.621-2.784C20.109,55.985,14,51.345,14,46.087V25.466m72.174,0c0,5.258-6.109,9.9-15.466,12.682a73.1,73.1,0,0,1-20.621,2.784,73.1,73.1,0,0,1-20.621-2.784C20.109,35.364,14,30.724,14,25.466",
    transform: "translate(22.252 7.486)",
    fill: "none",
    stroke: "#6c637b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_812",
    "data-name": "Trazado 812",
    d: "M6,32.551V53.172c0,5.258,6.109,9.9,15.466,12.682a73.1,73.1,0,0,0,20.621,2.784,73.094,73.094,0,0,0,20.621-2.784c9.357-2.784,15.466-7.424,15.466-12.682V48.016M6,32.551c0-6.161,8.429-11.5,20.621-13.971M6,32.551c0,5.258,6.109,9.9,15.466,12.682a73.1,73.1,0,0,0,20.621,2.784A82.6,82.6,0,0,0,52.4,47.372",
    transform: "translate(9.63 21.022)",
    fill: "none",
    stroke: "#6c637b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_813",
    "data-name": "Trazado 813",
    d: "M0,0H117.043V117.043H0Z",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContabilidad);
export default __webpack_public_path__ + "static/media/contabilidad.00a364009ba16d43903e13549324f0cf.svg";
export { ForwardRef as ReactComponent };